import script from "./TumorBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./TumorBoard.vue?vue&type=script&setup=true&lang=js"

import "./TumorBoard.vue?vue&type=style&index=0&id=57911348&lang=scss&scoped=true"
import "./TumorBoard.vue?vue&type=style&index=1&id=57911348&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57911348"]])

export default __exports__